import { isIOS } from 'react-device-detect'

const BODY_PADDING_DESKTOP = 'md:px-10'
const BODY_PADDING_MOBILE = 'px-5'
const BODY_MARGIN_DESKTOP = 'mx-10'
const BODY_MARGIN_MOBILE = 'mx-5'

const IOS_FULL_HEIGHT = isIOS
  ? {
      height: '-webkit-fill-available',
      // ios browser nav height: 120px
      minHeight: 'calc(100vh - 120px)',
    }
  : null

export {
  BODY_PADDING_DESKTOP,
  BODY_PADDING_MOBILE,
  BODY_MARGIN_DESKTOP,
  BODY_MARGIN_MOBILE,
  IOS_FULL_HEIGHT,
}
